import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SiteHeader } from '../components/landing/SiteHeader';
import { HeroBlock } from '../components/landing/HeroBlock';
import { PicoteDivider } from '../components/landing/PicoteDivider';
import { NumbersBanner } from '../components/landing/NumbersBanner';
import { HowItWorks } from '../components/landing/HowItWorks';
import { DemoBlock } from '../components/landing/DemoBlock';
import { FAQBlock } from '../components/landing/FAQBlock';
import { Closer } from '../components/landing/Closer';
import { Footer } from '../components/landing/Footer';

export default function LandingPage() {
  const navigate = useNavigate();
  const goLogin = () => navigate('/login');
  const goSignup = () => navigate('/login?mode=signup');

  return (
    <div className="min-h-screen bg-paper">
      <SiteHeader onLoginClick={goLogin} onSignupClick={goSignup} />
      <HeroBlock onPrimary={goSignup} onSecondary={goLogin} />
      <PicoteDivider />
      <NumbersBanner />
      <HowItWorks />
      <DemoBlock />
      <FAQBlock />
      <Closer onCta={goSignup} />
      <Footer />
    </div>
  );
}
